import React, { useEffect, useState } from 'react';
import './MainSectionFeedback.css';

const MainSectionFeedback = () => {
  const [widgetLoaded, setWidgetLoaded] = useState(false);

  useEffect(() => {
    let script;
    let interval;
    let observer;
    let resizeObserver;

    const loadWidget = () => {
      if (document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')) {
        return;
      }

      script = document.createElement('script');
      script.src = 'https://static.elfsight.com/platform/platform.js';
      script.async = true;
      script.defer = true;
      script.onload = () => setWidgetLoaded(true);
      document.body.appendChild(script);
    };

    const fixWidgetOverlap = () => {
      const widget = document.querySelector('.elfsight-app-1a1f00a2-b51b-47c7-b0b7-e54068755b76');
      if (widget) {
        widget.style.position = 'relative';
        widget.style.zIndex = '0';
        clearInterval(interval);
        setWidgetLoaded(true);
        
        
        resizeObserver = new ResizeObserver((entries) => {
          entries.forEach(entry => {
          });
        });
        resizeObserver.observe(widget);
      }
    };

    
    loadWidget();
    interval = setInterval(fixWidgetOverlap, 500);

    // Backup per lazy loading
    const section = document.querySelector('#reviews');
    if (section) {
      observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          loadWidget();
          observer.unobserve(section);
        }
      }, { threshold: 0.1 });
      observer.observe(section);
    }

    return () => {
      clearInterval(interval);
      if (resizeObserver) resizeObserver.disconnect();
      if (observer) observer.disconnect();
      
    };
  }, []);

  return (
    <section className="reviews-section" id="Reviews">
      <div className="reviews-container">
        <div className="reviews-header">
          <h2>Guestbook</h2>
        </div>

        <div className="reviews-widget">
          {!widgetLoaded && (
            <div className="reviews-loading">
              Loading testimonials...
            </div>
          )}
          <div 
            className="elfsight-app-1a1f00a2-b51b-47c7-b0b7-e54068755b76" 
            data-elfsight-app-lazy
          ></div>
        </div>
      </div>
    </section>
  );
};

export default MainSectionFeedback;